import { render, staticRenderFns } from "./PolygonModule.vue?vue&type=template&id=6d4a963c&scoped=true"
import script from "./PolygonModule.vue?vue&type=script&lang=js"
export * from "./PolygonModule.vue?vue&type=script&lang=js"
import style0 from "./PolygonModule.vue?vue&type=style&index=0&id=6d4a963c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4a963c",
  null
  
)

export default component.exports